import { Field, FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import Api from "../../../api";
import { capitalizeFirstLetter } from "../../../utils/words";
import InfoBox from "../../common/InfoBox";
import { BASE_URL } from "../../../utils/constants";
import { encrypt } from "../../../utils/encrypter";
import Button from "../../common/Button";
import useLoader from "../../../utils/useLoader";

function InviteUser({ setIsPageLoading }) {
  const [organizations, setOrganizations] = useState([]);
  const [info, setInfo] = useState({ title: "", message: "" });
  const { isLoading, setIsLoading } = useLoader();

  const getAllOrganizations = async () => {
    setIsPageLoading(true);
    const response = await Api.DataService.Orgs.getAllOrgs();
    if (!response.success) return;

    setOrganizations(response.data);
    setIsPageLoading(false);
  };

  useEffect(() => {
    getAllOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = (values) => {
    const errors = {};
    if (values.organizationID === "Select an organization") {
      errors.organizationID = "Organization is required";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      organizationID: "Select an organization",
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      const organizationID = values.organizationID;

      const org = organizations.find((item) => item.id === organizationID);

      const code = encrypt(
        JSON.stringify({ id: organizationID, name: org.name })
      );

      setInfo({
        title: `The invite link for ${capitalizeFirstLetter(
          org.name
        )} has been generated`,
        message: `${BASE_URL}/signup?code=${btoa(code)}`,
      });
      setIsLoading(false);
    },
    validate: validate,
  });

  return (
    <div className="invite-user-select-organization">
      <InfoBox title={info.title} message={info.message} />
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="organizationID">
            Select Organization<span className="input-required">*</span>
          </label>
          <Field
            id="organizationID"
            name="organizationID"
            as="select"
            initialValues={formik.initialValues.organizationID}
          >
            <option
              value="Select an organization"
              label="Select an organization"
            >
              Select an organization
            </option>
            {organizations.map((organization) => {
              return (
                <option
                  value={organization.id}
                  label={capitalizeFirstLetter(organization.name)}
                >
                  {capitalizeFirstLetter(organization.name)}
                </option>
              );
            })}
          </Field>
          {formik.errors.organizationID ? (
            <div className="input-error-message">
              {formik.errors.organizationID}
            </div>
          ) : null}
          <Button
            type="submit"
            isLoading={isLoading}
            label="Generate Invite Link"
          />
        </form>
      </FormikProvider>
    </div>
  );
}

export default InviteUser;
